import { AssetTag } from '@/feature/tags'

export const MULTIPLE_TAGS_LABEL = 'Multiple tags'

/**
 * A single tag is shown by name. More than one collapses to `MULTIPLE_TAGS_LABEL` rather than
 * stacking chips over the icon, which would quickly cover neighbouring markers. No tags means no
 * label at all.
 */
export const getTagLabel = (tags: AssetTag[] | undefined): string | undefined => {
  if (!tags?.length) return undefined

  return tags.length === 1 ? tags[0].name : MULTIPLE_TAGS_LABEL
}
